import type { DetailedHTMLProps, InputHTMLAttributes, Ref } from 'react';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

function TextInput(
  {
    error,
    className,
    ...props
  }: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    error?: boolean;
    className?: string;
  },
  ref: Ref<HTMLInputElement>,
) {
  return (
    <input
      {...props}
      ref={ref}
      className={twMerge(
        'block h-auto w-full rounded-sm border-0 px-3 py-2 text-base text-zinc-900 leading-6 shadow-xs ring-1 ring-zinc-300 ring-inset placeholder:text-zinc-400 focus:outline-hidden focus:ring-2 focus:ring-emerald-500 focus:ring-inset focus-visible:outline-hidden sm:text-sm dark:bg-white/5 dark:text-zinc-200 dark:ring-white/10 dark:focus:ring-emerald-400',
        !!error && 'ring-red-500',
        className,
      )}
    />
  );
}

export default forwardRef(TextInput);
